/**
 * 复制文本到剪贴板（公用方法）
 * @param {string} text - 要复制的文本
 * @returns {Promise<boolean>} 是否复制成功
 */
export function copyText(text) {
	if (!text) return Promise.resolve(false)
	if (navigator.clipboard && navigator.clipboard.writeText) {
		return navigator.clipboard.writeText(text).then(() => true).catch(() => false)
	}
	// 兼容旧浏览器
	return new Promise((resolve) => {
		const ta = document.createElement('textarea')
		ta.value = text
		ta.style.position = 'fixed'
		ta.style.left = '-9999px'
		document.body.appendChild(ta)
		ta.select()
		try {
			document.execCommand('copy')
			resolve(true)
		} catch (e) {
			resolve(false)
		}
		document.body.removeChild(ta)
	})
}

export default {
  // 日期格式化 fmt 格式化字符如 'yyyy-MM-dd hh:mm:ss' v 可以是日期或字符串
  time_10: function () {
    return Math.round(new Date().getTime() / 1000)
  },
  datetimeFormat: function (v, fmt) {
    if ((typeof v).toLocaleLowerCase() == 'string') { v = new Date(v.replace(/-/g, '/')) }
    var o = {
      'M+': v.getMonth() + 1, // 月份
      'd+': v.getDate(), // 日
      'h+': v.getHours(), // 小时
      'm+': v.getMinutes(), // 分
      's+': v.getSeconds(), // 秒
      'q+': Math.floor((v.getMonth() + 3) / 3), // 季度
      'S': v.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (v.getFullYear() + '').substr(4 - RegExp.$1.length)) }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },
  // 获取日期的星期 v=日期字符串或日期对象 返回值 0-6对应 周日-周六
  getWeek: function (v) {
    if ((typeof v).toLocaleLowerCase() == 'string') { v = new Date(v.replace(/-/g, '/')) }
    var end = v.getDay()
    return end
  },
  // 字符串转日期 v必须为 -格式 如 2020-05
  toDateTime: function (v) {
    if ((typeof v).toLocaleLowerCase() == 'string') { v = new Date(v.replace(/-/g, '/')) }
    return v
  },
  // 用于将数组进行name匹配 这里用作export2excel.js插件的智能字段识别导出
  formatJson: function (filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]))
  },

  ismobile: function (this_) {
    
    var userAgentInfo = navigator.userAgent;

    var mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];

    var mobile_flag = false;

    //根据userAgent判断是否是手机
    for (var v = 0; v < mobileAgents.length; v++) {
      if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
        mobile_flag = true;
        break;
      }
    }
    var screen_width = window.screen.width;
    var screen_height = window.screen.height;

    //根据屏幕分辨率判断是否是手机
    if (screen_width > 325 && screen_height < 750) {
      mobile_flag = true;
    }
    if(sessionStorage.getItem('ismobile_bts')){
      return
    }
    if(mobile_flag){
      this_.$confirm('检测到您是手机，建议下载手机版使用，体验更多功能', '提示', {
        confirmButtonText: '下载',
        cancelButtonText: '取消',
        customClass:'newdialog',
        type: 'warning'
        }).then(() => {
          
          if (/(micromessenger)/i.test(navigator.userAgent)) {
            this_.$router.push('/')
            return false
          }
          if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            location.href='https://apps.apple.com/cn/app/%E8%B5%B7%E5%8F%B7%E4%BA%91/id1609731577'
          } else {
            location.href='https://spk.siyoa.com/qhy/app/update/duoheios/2.2.0/duohe_v2.apk'
          }
        }).catch(() => {
          sessionStorage.setItem('ismobile_bts',true)
        });
    }
    
    return mobile_flag;
  },   
}


// WEBPACK FOOTER //
// ./src/common.js